import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["id"],
  _excluded2 = ["id"],
  _excluded3 = ["id"],
  _excluded4 = ["subscriptionId"],
  _excluded5 = ["subscriptionId"],
  _excluded6 = ["subscriptionId"],
  _excluded7 = ["subscriptionId", "changeId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { stripeRoutes } from './routes';
export class Stripe {
  constructor() {
    _defineProperty(this, "routes", stripeRoutes);
  }
  async getInvoices(options) {
    const resp = await requestService('stripe').get(this.routes.invoice, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getUpcomingInvoices(options) {
    const resp = await requestService('stripe').get(this.routes.invoiceUpcoming, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getMeter(options) {
    const resp = await requestService('stripe').get(this.routes.meter, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPrices(options) {
    const resp = await requestService('stripe').get(this.routes.price, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async createPrice(data, options) {
    const resp = await requestService('stripe').post(this.routes.price, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPriceDashboard(options) {
    const resp = await requestService('stripe').get(this.routes.priceDashboard, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getSubscriptionTemplates(options) {
    const resp = await requestService('stripe').get(this.routes.subscriptionTemplates, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updatePrice(data, options) {
    const id = data.id,
      rest = _objectWithoutProperties(data, _excluded);
    const resp = await requestService('stripe').put(this.routes.actionPriceById(id), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deletePrice(data, options) {
    const resp = await requestService('stripe').delete(this.routes.actionPriceById(data.id), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async detachPriceFromSubscription(data, options) {
    const resp = await requestService('stripe').post(this.routes.detachPriceFromSubscription, {
      data
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async bulkDeletePrices(data, options) {
    const resp = await requestService('stripe').post(this.routes.bulkDelete, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getCoupons(options) {
    const resp = await requestService('stripe').get(this.routes.coupon, _objectSpread({}, options.cancelToken));
    return resp.data;
  }

  /** Code lookup is case-insensitive on the backend. */
  async getCouponByCode(data, options) {
    const resp = await requestService('stripe').get(this.routes.couponByCode(data.code), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async createCoupon(data, options) {
    const resp = await requestService('stripe').post(this.routes.coupon, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateCoupon(data, options) {
    const id = data.id,
      rest = _objectWithoutProperties(data, _excluded2);
    const resp = await requestService('stripe').put(this.routes.couponById(id), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deleteCoupon(data, options) {
    const resp = await requestService('stripe').delete(this.routes.couponById(data.id), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getAllProducts(options) {
    const resp = await requestService('stripe').get(this.routes.product, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async createProduct(data, options) {
    const resp = await requestService('stripe').post(this.routes.product, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deleteProduct(data, options) {
    const resp = await requestService('stripe').delete(this.routes.productById(data.id), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateProduct(data, options) {
    const id = data.id,
      rest = _objectWithoutProperties(data, _excluded3);
    const resp = await requestService('stripe').put(this.routes.productById(id), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getSubscriptionDashboard(options) {
    const resp = await requestService('stripe').get(this.routes.subscriptionDashboard, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getSubscriptionsPaged(data, options) {
    const resp = await requestService('stripe').get(this.routes.subscription, _objectSpread({
      params: data
    }, options.cancelToken));
    return resp.data;
  }
  async createSubscription(data, options) {
    const resp = await requestService('stripe').post(this.routes.subscription, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateSubscription(data, options) {
    const subscriptionId = data.subscriptionId,
      rest = _objectWithoutProperties(data, _excluded4);
    const resp = await requestService('stripe').put(this.routes.updateSubscription(subscriptionId), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async bulkUpdateSubscriptions(data, options) {
    const resp = await requestService('stripe').post(this.routes.bulkUpdateSubscription, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getSubscriptionCompany(data, options) {
    const resp = await requestService('stripe').get(this.routes.subscriptionCompany, _objectSpread({
      params: data !== null && data !== void 0 && data.companyId ? {
        companyId: data.companyId
      } : undefined
    }, options.cancelToken));
    return resp.data;
  }
  async getScheduledChangeEstimate(data, options) {
    const subscriptionId = data.subscriptionId,
      params = _objectWithoutProperties(data, _excluded5);
    const resp = await requestService('stripe').get(this.routes.scheduleChangeEstimate(subscriptionId), _objectSpread({
      params
    }, options.cancelToken));
    return resp.data;
  }
  async scheduleChange(data, options) {
    const subscriptionId = data.subscriptionId,
      rest = _objectWithoutProperties(data, _excluded6);
    const resp = await requestService('stripe').post(this.routes.scheduleChange(subscriptionId), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async rescheduleChange(data, options) {
    const subscriptionId = data.subscriptionId,
      changeId = data.changeId,
      rest = _objectWithoutProperties(data, _excluded7);
    const resp = await requestService('stripe').patch(this.routes.rescheduleChange(subscriptionId, changeId), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async removeScheduledChange(data, options) {
    const resp = await requestService('stripe').delete(this.routes.removeScheduledChange(data.subscriptionId, data.changeId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}